import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/admin/css/style.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Login from './pages/login.component';
import Home from './pages/Home';
import NotFound from './pages/404';
import AdminRoutes from './routes/AdminRoutes'; // Import AdminRoutes
import AuthService from './services/AuthService';
import About from './pages/About';



// Auth Checker Component to Redirect Based on Authentication
const AuthChecker = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If the user is already authenticated, redirect them to the admin panel
    if (location.pathname === '/' && AuthService.isAuthenticated()) {
      navigate('/admin');
    }
    // If the user is not authenticated and tries to access a protected route, redirect to login
    if (location.pathname.startsWith('/admin') && !AuthService.isAuthenticated()) {
      AuthService.logout(); // Clear any invalid session
      navigate('/login');
    }
  }, [navigate, location]);

  return null;
};

// Main App Component
function App() {
  return (
    <Router>
      <AuthChecker />
      <div className="App">
        <div className="auth-wrapper">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/about" element={<About />} />

            {/* Admin Panel Routes - Protected */}
            <Route path="/admin/*" element={<AdminRoutes />} />

            {/* Catch-All Route for 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
